/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef } from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import SelectProduct from '@web-components/create-review/SelectProduct';
import ChooseCombination from '@web-components/create-review/ChooseCombination';
import ModalizeBase from '@web-components/modals/ModalizeBase';

const ModalAddReviewRecentlyBought = (props) => {
  const navigation = props.navigation?.current || null;
  const dispatch = useDispatch();
  const isShow = useSelector(
    (state) => state.modal.addReviewRecentlyBought.isShow,
  );
  const section = useSelector((state) => state.createReview.section);
  const modalizeRef = useRef(null);
  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'addReviewRecentlyBought' });
  };
  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);

  return (
    <ModalizeBase
      center
      ref={modalizeRef}
      onClosed={closeModal}
      withInsetsBottom={true}>
      {isShow && (
        <View style={styles.modalContainer}>
          {section === 'select_product' && (
            <SelectProduct navigation={navigation} />
          )}
          {section === 'choose_combination' && (
            <ChooseCombination navigation={navigation} />
          )}
        </View>
      )}
    </ModalizeBase>
  );
};
const styles = StyleSheet.create({
  modalContainer: {
    width: 655,
  },
});
export default ModalAddReviewRecentlyBought;
